export default "__VITE_ASSET__B3KXl4wY__"